import { useEffect } from 'react'
import config from 'configs'

export function useGoogleAnalytics(): void {
  useEffect(() => {
    if (!config?.googleAnalyticsTrackingId) {
      return
    }

    // Delay loading Google Analytics until after page load for better performance
    const loadAnalytics = () => {
      const initScript = document?.createElement('script')
      initScript.type = 'text/javascript'
      initScript.async = true
      initScript.src = `https://www.googletagmanager.com/gtag/js?id=${config?.googleAnalyticsTrackingId}`
      document.head.appendChild(initScript)

      const script = document?.createElement('script')
      script.type = 'text/javascript'
      script.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${config?.googleAnalyticsTrackingId}', {
                page_path: window.location.pathname
              });
            `
      document.head.appendChild(script)
    }

    // Load analytics after page is fully loaded or after a delay
    if (document.readyState === 'complete') {
      setTimeout(loadAnalytics, 1000) // 1 second delay
    } else {
      window.addEventListener('load', () => {
        setTimeout(loadAnalytics, 1000)
      })
    }
  }, [config])
}
